import { createSelector } from 'reselect';
import { LayoutType } from '../../types/layouts.esm.js';

var getPredefinedLayoutNames = function getPredefinedLayoutNames(layouts) {
  return layouts.filter(function (l) {
    return (l === null || l === void 0 ? void 0 : l.type) === LayoutType.Predefined;
  }).map(function (l) {
    return l.label || '';
  });
};
var createPredefinedLayoutNamesSelector = function createPredefinedLayoutNamesSelector() {
  return createSelector(function (layouts) {
    return layouts;
  }, getPredefinedLayoutNames);
};

export { createPredefinedLayoutNamesSelector, getPredefinedLayoutNames };
//# sourceMappingURL=predefined-layout-names-selector.esm.js.map
